// This is not a selector, just a constant. We need to keep it somewhere...
export const appName = 'Conduit';
